import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const pet_treatment = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath(
        'no_recent_surgery_or_treatment_recommendation_confirmation'
      )]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_treatment.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath(
          'no_recent_surgery_or_treatment_recommendation_confirmation'
        ),
        options: [
          {
            value: false,
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
          },
          {
            value: true,
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath(
        'no_recent_surgery_or_treatment_recommendation_confirmation'
      ),
      valueToStepName: {
        true: 'pet_conditions',
        false: 'failure',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pet_treatment
